import protection from "../images/protection.png";

export const investmentPlans = [
  {
    name: "Validator Prime",
    image: protection,
    price: "$50 - $999",
    amount: 50,
    duration: 3,
    durationDisplay: "3 days",
    profit: 65,
    hardware: "2x CPU Cores | 1x GPU (NVIDIA T4)",
    efficiency: "75% Guaranteed",
    chains: "Ethereum, BSC, Polygon",
    tps: "Compliance-ready staking with control over validators, MEV optimization, and liquidity access.",
    maxTps: 250,
    specs: [
      "4GB DDR4 RAM",
      "100GB SSD Storage",
      "1Gbps Network",
      "Basic Cooling System"
    ]
  },
  {
    name: "Node Elite",
    image: protection,
    price: "$1,000 - $2,999",
    amount: 1000,
    duration: 5,
    durationDisplay: "5 days",
    profit: 75,
    hardware: "4x CPU Cores | 2x GPU (NVIDIA RTX 3060)",
    efficiency: "85% Guaranteed",
    chains: "Ethereum, Solana, Avalanche",
    tps: "Custom staking for high-volume clients with L1 integration and scalable TVL growth.",
    maxTps: 850,
    specs: [
      "16GB DDR4 RAM",
      "500GB NVMe SSD",
      "2.5Gbps Network",
      "Liquid Cooling"
    ]
  },
  {
    name: "DeFi Architect",
    image: protection,
    price: "$3,000 - Unlimited",
    amount: 3000,
    duration: 1,
    durationDisplay: "1 day",
    profit: 90,
    hardware: "8x CPU Cores | 4x GPU (NVIDIA RTX 4090)",
    efficiency: "94% Guaranteed",
    chains: "Ethereum, Solana, Sui",
    tps: "Advanced DeFi products with dynamic collateral models for institutional-grade deployments.",
    maxTps: 2100,
    specs: [
      "32GB DDR5 RAM",
      "1TB NVMe SSD",
      "10Gbps Network",
      "Enterprise Cooling"
    ]
  },
  {
    name: "Metal Reserve",
    image: protection,
    price: "$5,000 - $10,000",
    amount: 1000,
    duration: 14,
    durationDisplay: "14 days",
    profit: 120,
    hardware: "Allocated Gold Storage & Digital Contracts",
    efficiency: "Gold-backed Stability",
    chains: "Gold, Silver, Platinum",
    tps: "Direct exposure to rare metals with secure, insured storage and digital redemption options.",
    maxTps: 100,
    specs: [
      "Allocated Bullion Accounts",
      "London Good Delivery Certified",
      "Audited Vault Access",
      "Hedge Against Inflation"
    ]
  }
];
